// For the OnAuxClick event handler: event.button is a number mapped here
export const AUX_CLICK_BUTTON = {
  MIDDLE: 1,
  RIGHT: 2,
};
